import { isHosted, SsaEnabledHelperClass } from '../utils';
import { acquireAccessToken } from './acquireAccessToken';

type TempStorage = {
  [key: string]: any;
};

type RequestOptionsType = Omit<RequestInit, 'body'> & {
  contentType?: string;
  body?: any;
};

const tempStorage: TempStorage = {
  accessToken: null,
};

/**
 * Method to get the user token.
 * @returns {Promise<string>} - The user token.
 */
export const getUserToken = async () => {
  if (isHosted()) {
    if (tempStorage.accessToken) return tempStorage.accessToken;
    const response = await fetch('/user/GetAccessToken');
    const { accessToken } = await response.json();
    tempStorage.accessToken = accessToken;
    return accessToken;
  }
  const accessToken = await acquireAccessToken(
    window.msalInstance.current,
    window.scopesRef.current
  );
  return accessToken;
};

/**
 * Method to get the request options.
 * @param contentType
 * @param body
 * @param options
 */
const getRequestOptions = async ({
  contentType = 'application/json',
  body = null,
  ...options
}: RequestOptionsType): Promise<RequestInit> => {
  const { isSsaEnabled } = SsaEnabledHelperClass;
  if (isSsaEnabled()) {
    return {
      ...options,
      credentials: 'include',
      headers: {
        'Content-Type': contentType,
        ...(options?.headers || {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    } as RequestInit;
  }

  const accessToken = await getUserToken();
  return {
    ...options,
    headers: {
      'Content-Type': contentType,
      ...(options?.headers || {}),
      Authorization: `Bearer ${accessToken}`,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  } as RequestInit;
};

/**
 * Fetch method to make an authenticated request to the API.
 * @param url - The URL to fetch.
 * @param param1 - Additional options for the request.
 * @returns {Promise<Response | null>} - The fetch response or null if an error occurs.
 */
export const request = async (
  url: string,
  {
    contentType = 'application/json',
    body = null,
    ...options
  }: RequestOptionsType
) => {
  try {
    const requestInit = await getRequestOptions({
      contentType,
      body,
      ...options,
    } as RequestInit);
    return await fetch(url, requestInit);
  } catch (error) {
    console.error('Error:login:request', { error });
    return null;
  }
};
